import { t } from '@lingui/core/macro';

export const getDefaultRejectReason = (hasMultipleOffers: boolean) => {
  if (hasMultipleOffers) {
    return t`These offers were rejected.`;
  } else {
    return t`This offer was rejected.`;
  }
};
